import moment from "moment"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router"
import {
  END_DATE,
  START_DATE,
  SUBTRACT,
  TWO_WEEKS
} from "src/blitz/DateRange/constant"
import {
  checkInValidDate,
  getCalculatedDay,
  getDateDifference
} from "src/blitz/DateRange/helper"
import { selectBuildingSummary } from "src/redux/slicers/buildingSummarySlice"

export const useQueryDateValuesNewDesign = (diableDateDiffCheck = false) => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const queryStartDate = queryParams.get(START_DATE)?.split("-")?.join("/")
  const queryEndDate = queryParams.get(END_DATE)?.split("-")?.join("/")
  const { data: building } = useSelector(selectBuildingSummary)
    const localDate = useMemo(
    () => building?.localTime ? moment(new Date(building?.localTime)).toDate() : new Date(),
    [building?.localTime]
  )

  const defaultDates = useMemo(
    () =>
      diableDateDiffCheck
        ? checkInValidDate(queryStartDate) ||
        checkInValidDate(queryEndDate) ||
        new Date(queryStartDate) >= new Date(queryEndDate)
        : checkInValidDate(queryStartDate) ||
        checkInValidDate(queryEndDate) ||
        new Date(queryStartDate) >= new Date(queryEndDate) ||
        getDateDifference(queryEndDate, queryStartDate) < 14,
    [queryStartDate, queryEndDate]
  )
  const startDate = useMemo(
    () =>{
    //  return defaultDates
    //     ? diableDateDiffCheck ? moment(localDate)?.subtract({ months: 3 })?.add({ days: 1 })?.toDate() : new Date(queryStartDate)
    //     : new Date(queryStartDate)
    return new Date(queryStartDate)
      },
    [defaultDates, queryStartDate]
  )
  const endDate = useMemo(
    () =>{
      // return defaultDates ? localDate : new Date(queryEndDate)
      return  new Date(queryEndDate)
    },
    [defaultDates, queryEndDate]
  )

  return {
    queryStartDate,
    queryEndDate,
    defaultDates,
    startDate,
    endDate
  }
}
